<template>
    <div class="container">
        <div class="left">
            <!-- 背景图 由于分层问题目前使用定位实现效果 -->
            <img class="bg" src="../../assets/school/bg.png" alt=""/>
            <!-- 学校 -->
            <div class="top">
                <div class="card">
                    <img class="logo" :src="school_extra_info.logo" alt=""/>
                    <div class="center">
                        <div class="name">
                            <div>{{ school_extra_info.name }}</div>
                            <div class="city">
                                <el-icon color="#FFFFFF" size="14">
                                    <Location/>
                                </el-icon>
                                <div style="margin-left: 2px">{{ school_extra_info.province_name }}</div>
                            </div>
                        </div>
                        <div class="types">
                            <div v-if="school_extra_info.nature_str !== ''">{{ school_extra_info.nature_str }}</div>
                            <div v-if="school_extra_info.level !== ''">{{ school_extra_info.level }}</div>
                            <div v-if="school_extra_info.subject_attribute !== ''">
                                {{ school_extra_info.subject_attribute }}
                            </div>
                            <div v-if="school_extra_info.belong !== ''">{{ school_extra_info.belong }}</div>
                            <div v-if="school_extra_info.postgraduate !== ''">{{ school_extra_info.postgraduate }}</div>
                        </div>
                        <div class="labels">
                            <div v-for="item in school_extra_info.labels">{{ item }}</div>
                        </div>
                    </div>
                    <!--                    <div class="button">关注</div>-->
                </div>
                <div class="tabbar">
                    <div @click="changeTab(1)" :class="tab === 1 ? 'onbar' : 'bar'">
                        院校概况
                    </div>
                    <div @click="changeTab(2)" :class="tab === 2 ? 'onbar' : 'bar'">
                        招生简章
                    </div>
                    <div @click="changeTab(3)" :class="tab === 3 ? 'onbar' : 'bar'">
                        招生计划
                    </div>
                </div>
            </div>
            <!-- 介绍 -->
            <div class="bottom" style="display: flex;justify-content: space-between;" v-show="tab === 1">
                <div>
                    <div class="medal">
                        <div class="list" v-if="school_extra_info.banxiaoshijian !== ''">
                            <img src="../../assets/school/icon1.png" alt=""/>
                            <div class="text">{{ school_extra_info.banxiaoshijian }}</div>
                            <div class="gang"></div>
                        </div>
                        <div class="list" v-if="school_extra_info.nature_str !== ''">
                            <img src="../../assets/school/icon2.png" alt=""/>
                            <div class="text">{{ school_extra_info.nature_str }}</div>
                            <div class="gang"></div>
                        </div>
                        <div class="list" v-if="school_extra_info.subject_attribute !== ''">
                            <img src="../../assets/school/icon3.png" alt=""/>
                            <div class="text">{{ school_extra_info.subject_attribute }}</div>
                            <div class="gang"></div>
                        </div>
                        <div class="list" v-if="school_extra_info.level !== ''">
                            <img src="../../assets/school/icon4.png" alt=""/>
                            <div class="text">{{ school_extra_info.level }}</div>
                            <div class="gang"></div>
                        </div>
                        <div class="list" v-if="school_extra_info.belong !== ''">
                            <img src="../../assets/school/icon5.png" alt=""/>
                            <div class="text">{{ school_extra_info.belong }}</div>
                            <div class="gang"></div>
                        </div>
                        <div class="list"
                             v-if="school_extra_info.province_name !== '' || school_extra_info.city_name !== ''">
                            <img src="../../assets/school/icon6.png" alt=""/>
                            <div class="text">
                                {{ school_extra_info.province_name }} ·
                                {{ school_extra_info.city_name }}
                            </div>
                            <div class="gang"></div>
                        </div>
                        <div class="list"
                             v-if="school_extra_info.yijishuoshidian > 0 || school_extra_info.erjishuoshidian > 0">
                            <img src="../../assets/school/icon7.png" alt=""/>
                            <div style="margin-bottom: 0" class="text">
                                一级: {{ school_extra_info.yijishuoshidian }} <br/>
                                二级: {{ school_extra_info.erjishuoshidian }}
                            </div>
                        </div>
                        <div class="list" v-if="school_extra_info.yijiboshidian > 0 || school_extra_info.erjiboshidian">
                            <img src="../../assets/school/icon8.png" alt=""/>
                            <div style="margin-bottom: 0" class="text">
                                一级: {{ school_extra_info.yijiboshidian }} <br/>
                                二级: {{ school_extra_info.erjiboshidian }}
                            </div>
                        </div>
                    </div>
                    <div class="introduction">
                        <div v-html="school_extra_info.content"></div>
                    </div>
                    <div class="introduction">
                        <div style="margin-right: 10px;"
                             v-if="school_extra_info.address !== undefined && school_extra_info.address !== ''">
                            <span style="background-color: #e93a29">&nbsp;</span>
                            {{ school_extra_info.address }}
                        </div>
                        <div style="margin-right: 10px;"
                             v-if="school_extra_info.phone !== undefined && school_extra_info.phone !== ''">
                            <span style="background-color: #e93a29">&nbsp;</span>
                            {{ school_extra_info.phone }}
                        </div>
                        <div style="margin-right: 10px;"
                             v-if="school_extra_info.school_site !== undefined && school_extra_info.school_site !== ''">
                            <span style="background-color: #e93a29">&nbsp;</span>
                            <a target="_blank" :href="school_extra_info.school_site">
                                {{ school_extra_info.school_site }}
                            </a>
                        </div>
                    </div>
                    <div class="map">
                        <div style="margin-top: 10px;margin-right: 30px;">
                            <div id="gaodeditu" style="width:830px;height:300px;"></div>
                            <div style="width: 100%;">
                                <div style="margin-top: 5px;cursor: pointer;float: right"
                                     @click="school_map(school_name)">
                                    <span class="iconfont_small">&#xe64b;</span>点击查看大图
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 校园风采 -->
                    <div class="title" style="display:none;">
                        <div class="title_left">
                            <img src="../../assets/school/title.png" alt=""/>
                            <div class="font">校园风采</div>
                        </div>
                        <div class="more">
                            <div>查看更多</div>
                            <div>》</div>
                        </div>
                    </div>
                    <div class="mien" style="display:none;">
                        <img src="../../assets/school/zs1.png" alt=""/>
                        <img src="../../assets/school/zs2.png" alt=""/>
                        <img src="../../assets/school/zs3.png" alt=""/>
                    </div>
                    <!-- 招生简章 -->
                    <div class="title">
                        <div class="title_left">
                            <img src="../../assets/school/title.png" alt=""/>
                            <div class="font">招生简章</div>
                        </div>
                    </div>
                    <div class="student">
                        <div v-for="(item, index) in short_enroll_list_info" :key="index"
                             @click="show_enroll_info(item.id, item.title)">
                            {{ item.title }}
                        </div>
                    </div>
                    <!-- 一流学科 -->
                    <div class="title">
                        <div class="title_left">
                            <img src="../../assets/school/title.png" alt=""/>
                            <div class="font">一流学科</div>
                        </div>
                    </div>
                    <div class="table">
                        <el-table :data="first_class_info" stripe style="width: 100%" :empty-text="first_class_empty">
                            <el-table-column prop="name" label="专业" align="center">
                                <template #default="scope">
                                    <div style="height:20px;line-height: 20px;text-align: left;">
                                        {{ scope.row.name }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="code" label="专业代码" align="center">
                                <template #default="scope">
                                    <div style="height:20px;line-height: 20px;text-align: left;">
                                        {{ scope.row.code }}
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="title">
                        <div class="title_left">
                            <img src="../../assets/school/title.png" alt=""/>
                            <div class="font">学科评估</div>
                        </div>
                    </div>
                    <div class="table">
                        <el-table :data="subject_review_info" stripe style="width: 100%"
                                  :empty-text="subject_review_empty">
                            <el-table-column prop="assess" label="评级" width="180" align="center">
                                <template #default="scope">
                                    <div style="line-height: 30px;padding: 5px 0;">
                                        {{ scope.row.assess }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="major_name" label="学科名称" align="center">
                                <template #default="scope">
                                    <div style="line-height: 30px;padding: 5px 0;text-align: left;">
                                        {{ scope.row.major_name }}
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="title" style="display: none;">
                        <div class="title_left">
                            <img src="../../assets/school/title.png" alt=""/>
                            <div class="font">国家特色专业</div>
                        </div>
                    </div>
                    <div class="table" style="display: none;">
                        <el-table :data="special_major_info" stripe style="width: 100%"
                                  :empty-text="special_major_empty">
                            <el-table-column prop="type" label="批次" width="180" align="center">
                                <template #default="scope">
                                    <div style="line-height: 30px;padding: 5px 0;">
                                        {{ scope.row.type }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="major_name" label="专业名称" align="center">
                                <template #default="scope">
                                    <div style="line-height: 30px;padding: 5px 0;text-align: left;">
                                        {{ scope.row.major_name }}
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <!-- 开设专业 -->
                    <div class="title">
                        <div class="title_left">
                            <img src="../../assets/school/title.png" alt=""/>
                            <div class="font">开设专业</div>
                            <div class="detail">注:（硕）（博）分别表示本校有相关专业的硕士点和博士点</div>
                        </div>
                    </div>
                    <div class="table">
                        <el-table :data="department_info" stripe style="width: 100%"
                                  :empty-text="department_empty">
                            <el-table-column prop="l2_name" label="类别" width="200" align="center">
                                <template #default="scope">
                                    <div style="line-height: 30px;padding: 5px 0;">
                                        {{ scope.row.l2_name }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="major_name" label="专业" align="center">
                                <template #default="scope">
                                    <div style="line-height: 30px;padding: 5px 0;text-align: left;"
                                         v-html="scope.row.major_name"></div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div>
                    <Ranking :school_extra_info="school_extra_info" category="院校排名" type="academy"
                             style="margin-bottom: 10px"/>
                    <HotSchool :schools="hot_school" category="推荐院校"/>
                </div>
            </div>
            <div class="bottom" style="width:100%;" v-if="tab === 2">
                <div class="title">
                    <div class="title_left">
                        <img src="../../assets/school/title.png" alt=""/>
                        <div class="font">招生简章</div>
                    </div>
                </div>
                <div v-if="show_enroll_detail" style="width: 96%;">
                    <div style="margin: 20px auto;width: 100%;text-align: center">
                        <h3 style="display: inline-block">{{ enroll_detail_title }}</h3>
                    </div>
                    <div v-html="enroll_detail"></div>
                </div>
                <div v-else>
                    <div class="student" style="padding-right: 20px;display: flex;justify-content: left">
                        <div v-for="(item, index) in short_enroll_list_info" :key="index"
                             style="margin-right: 20px;width:500px;"
                             @click="show_enroll_info(item.id, item.title)">
                            {{ item.title }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom" style="width: 96.5%;" v-if="tab === 3">
                批次
                <el-select v-model="batch_id" class="m-2" placeholder="请选择批次" style="width:400px;"
                           @change="batch_change">
                    <el-option
                        v-for="item in province_zhanshi_fangshi"
                        :key="item.batch_id"
                        :label="item.batch_name"
                        :value="item.batch_id"
                    />
                </el-select>
                <div v-if="batch_info.recruit_form === 'major_class'">
                    <ClassPlanList
                        :plans="tableData"
                        :user_power="user_power"
                        :province_score_gailv="province_score_gailv"
                        :province_score_chongwenbao="province_score_chongwenbao"
                        :system_tips_list="system_tips_list"
                        @show_majors_job="show_majors_job"
                        @un_favorite="un_favorite"
                        @favorite="favorite"
                        @no_match_major="no_match_major"
                        @school_info="school_info"
                        @school_map="school_map"
                    >
                    </ClassPlanList>
                </div>
                <div v-else-if="batch_info.recruit_form === 'major_group'">
                    <GroupPlanList
                        :plans="tableData"
                        :sub_plans="sub_favorite_list"
                        :user_power="user_power"
                        :province_score_gailv="province_score_gailv"
                        :province_score_chongwenbao="province_score_chongwenbao"
                        :search_type="1"
                        :show_chose_plan="false"
                        :batch_pre="batch_info.batch_pre"
                        :system_tips_list="system_tips_list"
                        @show_majors_job="show_majors_job"
                        @un_favorite="un_favorite"
                        @favorite="favorite"
                        @change="change"
                        @sub_plans_list="sub_plans_list"
                        @no_match_major="no_match_major"
                        @school_info="school_info"
                        @school_map="school_map"
                    >
                    </GroupPlanList>
                </div>
                <div v-else-if="batch_info.recruit_form === 'school_strategy'">
                    <SchoolPlanList
                        :plans="tableData"
                        :sub_plans="sub_favorite_list"
                        :user_power="user_power"
                        :show_chose_plan="false"
                        :province_score_gailv="province_score_gailv"
                        :province_score_chongwenbao="province_score_chongwenbao"
                        :search_type="1"
                        :batch_pre="batch_info.batch_pre"
                        :system_tips_list="system_tips_list"
                        @show_majors_job="show_majors_job"
                        @un_favorite="un_favorite"
                        @favorite="favorite"
                        @change="change"
                        @sub_plans_list="sub_plans_list"
                        @no_match_major="no_match_major"
                        @school_info="school_info"
                        @school_map="school_map"
                    >
                    </SchoolPlanList>
                </div>
            </div>
        </div>
        <div class="right" style="display: none;">
            <Ranking :school_extra_info="school_extra_info" category="院校排名" type="academy"
                     style="margin-bottom: 10px"/>
            <HotSchool :schools="hot_school" category="推荐院校"/>
        </div>
    </div>
    <el-dialog v-model="favorites_status" title="专业特别提示" :show-close="false" width="30%"
               :before-close="handleClose">
        <div style="font-size: 16px;margin-left: 35px;margin-bottom:15px;" v-for="item in major_remind_list">
            {{ item }}
        </div>
        <template #footer>
			<span class="dialog-footer">
				<el-button @click="favorites_status = false">放弃</el-button>
				<el-button type="primary" @click="continue_favorite">继续选择</el-button>
			</span>
        </template>
    </el-dialog>
    <el-dialog v-model="no_login" title="提示" width="30%" :before-close="handleClose">
        <span>{{ no_login_msg }}</span>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="no_login_fun">取消</el-button>
                <el-button type="primary" @click="login_fun">
                  好的
                </el-button>
            </span>
        </template>
    </el-dialog>
    <el-dialog v-model="open_vip" title="提示" width="30%" :before-close="handleClose">
        <span>请在开通vip后查看更多</span>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="open_vip = false">取消</el-button>
                <el-button type="primary" @click="open_vip_fun">
                  好的
                </el-button>
            </span>
        </template>
    </el-dialog>
    <el-dialog
        v-model="show_majors_job_info"
        title="就业方向"
        width="60%"
        :before-close="majors_job_info_close">
        <div style="overflow-y: scroll;max-height: 600px;">
            <div v-if="majors_job_info === null || majors_job_info.length < 1">暂无数据</div>
            <div v-else-if="majors_job_list.length < 1">加载中...</div>
            <div v-else>
                <div v-for="item in majors_job_info">
                    <div style="font-size: 18px;font-weight: bold;color:#f56c6c;">
                        {{ item.name }}
                        <span style="margin-left: 20px;font-size:14px;cursor: pointer;color:#333333;"
                              @click="show_major_detail(item.name, item.code)">点击查看详情>></span>
                    </div>
                    <div style="margin-bottom: 10px;" v-if="majors_job_list[item.code] !== undefined">
                        <span style="margin-right: 10px;color:#666666;"
                              v-html="majors_job_list[item.code]['job_orientation']"></span>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button size="small" type="primary" @click="majors_job_info_close">关闭</el-button>
          </span>
        </template>
    </el-dialog>
</template>

<script>
import Ranking from "@/components/ranking.vue";
import env from "@/utils/env";
import belong from "@/assets/schoolinfo/belong.png";
import bo from "@/assets/schoolinfo/bo.png";
import create from "@/assets/schoolinfo/create.png";
import gongxin from "@/assets/schoolinfo/gongxin.png";
import local from "@/assets/schoolinfo/local.png";
import native from "@/assets/schoolinfo/native.png";
import shuo from "@/assets/schoolinfo/shuo.png";
import type from "@/assets/schoolinfo/type.png";
import api from "@/api";
import axios from "axios";
import {ElMessage} from "element-plus";
import http from "@/utils/http";
import AMapLoader from "@amap/amap-jsapi-loader";
import SchoolPlanList from "@/components/SchoolPlanList.vue";
import GroupPlanList from "@/components/GroupPlanList.vue";
import ClassPlanList from "@/components/ClassPlanList.vue";
import HotSchool from "@/components/HotSchool.vue";

export default {
    components: {
        HotSchool,
        Ranking, SchoolPlanList, GroupPlanList, ClassPlanList
    },
    data() {
        return {
            tab: 1,
            url: env[process.env.NODE_ENV].JSON_SITE,
            vocation_api: env[process.env.NODE_ENV].VOCATION_API,
            ben_api: env[process.env.NODE_ENV].API,
            arts_api: env[process.env.NODE_ENV].ART_API,
            preb_api: env[process.env.NODE_ENV].PRE_API,
            favorites_index: 0,
            favorites_list: [],
            show_majors_job_info: false,
            majors_job_info: [],
            majors_job_list: [],
            favorites_type: 1,
            major_remind_list: [],
            favorites_status: false,
            school_type: 'info',
            search_recruit: '',
            school_class: '',
            score_class: '',
            school_id: 0,
            show_majors_job: 1,
            belong: belong,
            bo: bo,
            create: create,
            gongxin: gongxin,
            local: local,
            native: native,
            shuo: shuo,
            type: type,
            school_extra_info: {content: ''},
            enroll_list_info: [],
            short_enroll_list_info: [],
            first_class_info: [],
            special_major_info: [],
            subject_review_info: [],
            department_info: [],
            jobs_report_info: [],
            score_list: [],
            plans_info: [],
            plans_empty: ' ',
            score_empty: ' ',
            enroll_list_empty: ' ',
            department_empty: ' ',
            special_major_empty: ' ',
            subject_review_empty: ' ',
            first_class_empty: ' ',
            short_enroll_list_empty: ' ',
            show_school_info: false,
            more_school_info: '',
            show_enroll_detail: false,
            enroll_detail_title: '',
            enroll_detail: '',
            school_name: '',
            from: 1,
            page: 1,
            batch: '',
            oss_url_list: [],
            province_zhanshi_fangshi: {},
            batch_info: {},
            base_info: {vip_level:0},
            batch_id: 0,
            plan_info: {
                "collection": -2,
                "foreign_study_mode": "",
                "foreign_universities": "",
                "foreign_rules": "",
                "province_id": 0,
                "province_name": "",
                "major_group_code": "",
                "school_pre": "",
                "batch_name": "",
                "school_guarantee_rate": "",
                "double_first_class_level": "",
                "majors": "",
                "majors_name": "",
                "majors_list": [],
                "majors_count": 0,
                "new_major": 0,
                "major_remind_desc": [],
                "school_id": 0,
                "school_logo": "",
                "school_name": "",
                "address": "",
                "school_code": "",
                "major_num": "",
                "nature_str": "",
                "nation_feature": "",
                "postgraduate_str": "",
                "type_str": "",
                "district_info": 0,
                "school_topic_info": 0,
                "major_topic_info": 0,
                "score_topic": 0,
                "diff": "",
                "use_sum": "",
                "forecast_low_score": 0,
                "forecast_match_precedence": 0,
                "discipline_ranking_major_str": "",
                "postgraduate_major_str": "",
                "doctor_major_str": "",
                "first_class_major_str": "",
                "label_list": [],
                "num": 0,
                "length": 0,
                "fees": "0",
                "major_group_rule": "",
                "historical_data": {},
                "xuanke_rule": {},
                "remarks": "",
                "majors_remarks": "",
                "postgraduate": 0,
            },
            system_tips_list: {
                1: {name: '等效分'},
                2: {name: '上段位变化量'},
                3: {name: '本校招生变化量'},
                4: {name: ''},
                5: {name: '位次'}
            },
            hot_school: [
                {
                    'name': '浙江大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/eb6b75745f25fa1e66362052e0e08f4d62e16f87.jpg',
                    'url': '',
                    'school_id': '184',
                },
                {
                    'name': '上海交通大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/598c92b43ae53c11bdbfaa9f1143ab0fabe2354e.jpg',
                    'url': '',
                    'school_id': '195',
                },
                {
                    'name': '复旦大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/58978cb6515f194b491ab8305f386975b391aec2.jpg',
                    'url': '',
                    'school_id': '202',
                },
                {
                    'name': '西安交通大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/ae279abdc4f5a35b18044284fc6568f6070315ec.jpg',
                    'url': '',
                    'school_id': '389',
                },
                {
                    'name': '四川大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/fc436a9dc8d57060ee67ec49ff69e2f6873e1943.jpg',
                    'url': '',
                    'school_id': '169',
                },
                {
                    'name': '南方科技大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/f29f974a02e51eccf5ac4f1152a9f1d3198bb0b0.jpg',
                    'url': '',
                    'school_id': '2496',
                },
                {
                    'name': '北京航空航天大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/4226c1856f019c64ad0accbb6a3ca046b8d8db8f.jpg',
                    'url': '',
                    'school_id': '118',
                },
                {
                    'name': '太原理工大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/51e6abab2a2cb7c2b969d3a547e99853132bf7d8.jpg',
                    'url': '',
                    'school_id': '209',
                },
                {
                    'name': '深圳大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/5b48e7957758956dba233e40ea2cead151537dc2.jpg',
                    'url': '',
                    'school_id': '349',
                },
            ],
            form: {
                provinces: [],
                type: [],
                educational_type: [],
                level: [],
                school_level: [],
                recruit_type: [],
                nature_type: [],
                school_ids: [],
                follow_major: [],
                major_one: 0,
                level_one: 0,
                major_two: [],
                level_two: [],
                page_size: 10,
                total: 0,
                page: 1,
                search_type: 1,
                score_range: 2,
            },
            tableData: [],
            subTableData: [],
            sub_favorite_list: [],
            oss_sheng_list: [],
            province_score_gailv: [],
            province_score_toudang_gailv: [],
            province_score_chongwenbao: [],
            province_id: 0,
            no_login: false,
            open_vip: false,
            no_login_msg: '请登录并完善分数信息后查看',
            need_login: false,
            user_power: {'show_major_label': 1, 'submit_report': 1},
        };
    },
    mounted() {
        let query = this.$route.query;
        
        if (query.school_id !== undefined) {
            this.school_id = query.school_id
            this.school_name = query.school_name
            
            this.from = query.from
            this.from = parseInt(this.from)
            
            this.page = query.page || 1
            if (this.from === 2) {
                this.batch = query.batch
            }
            this.get_oss_list()
        }
        
        this.initMap(this.school_name)
    },
    destroyed() {
    },
    created() {
        this.init()
    },
    methods: {
        changeTab(val) {
            this.tab = parseInt(val);
            
            if (this.tab === 2) {
                this.initMap(this.school_name)
                this.show_school_info = false
            }
            if (this.tab === 3) {
                if (this.need_login) {
                    this.no_login = true
                } else {
                    if(this.base_info.vip_level < 60){
                        this.open_vip = true
                    }else{
                        this.plans()
                    }
                }
            }
            window.scrollTo(0, 0); // 滚动到顶部
            this.show_enroll_detail = false
        },
        init() {
            let base_info = localStorage.getItem('base_info') || ''
            if (base_info !== null && base_info !== 'null' && base_info !== '[]' && base_info !== '' && base_info !== 'undefined') {
                base_info = JSON.parse(base_info)
                this.base_info = base_info
                this.province_id = localStorage.getItem('province_id') || 0
                //console.log('-----------this.base_info.score ----------------')
                //console.log(this.base_info.score)
                //console.log(this.base_info.class_id)
                if (this.base_info.score === undefined || this.base_info.score < 1 || this.base_info.class_id === undefined || this.base_info.class_id < 1) {
                    this.need_login = true
                    this.no_login_msg = '请完善分数信息后查看'
                } else {
                    this.get_sheng_oss_list()
                }
            } else {
                this.need_login = true
            }
        },
        show_major_detail(major_name, major_code) {
            let page = this.$router.resolve({
                path: '/tools',
                query: {type: 'zhuanye', major_code: major_code, major_name: major_name}
            })
            window.open(page.href, '_blank')
        },
        majors_job_info_close() {
            this.show_majors_job_info = !this.show_majors_job_info
            this.majors_job_info = []
            this.majors_job_list = []
        },
        get_sheng_oss_list() {
            let that = this
            let url = api.oss.sheng_list.replace('placeholder', this.province_id) + '?t=' + (Date.now() + '')
            axios.get(
                url, {}
            ).then(function (res) {
                that.oss_sheng_list = res.data
                that.get_province_zhanshi_fangshi()
            }).catch(function (err) {
            });
        },
        get_chongwenbao() {
            let that = this
            let gailv_url = that.oss_sheng_list.province_score_gailv.replace('placeholder', that.province_id + '/' + that.base_info.class_id + '/' + that.batch_id + '/' + that.base_info.score)
            let chongwenbao_url = that.oss_sheng_list.province_score_chongwenbao.replace('placeholder', that.province_id + '/' + that.base_info.class_id + '/' + that.batch_id + '/' + that.base_info.score)
            let toudang_gailv_url = that.oss_sheng_list.province_score_toudang_gailv.replace('placeholder', that.province_id + '/' + that.base_info.class_id + '/' + that.batch_id + '/' + that.base_info.score)
            axios.all(
                [axios.get(gailv_url), axios.get(chongwenbao_url), axios.get(toudang_gailv_url)]
            ).then(
                axios.spread((gailv_Res, chongwenbao_Res, toudang_gailv_Res) => {
                    that.province_score_gailv = gailv_Res.data
                    localStorage.setItem('province_score_gailv', JSON.stringify(gailv_Res.data))
                    
                    that.province_score_chongwenbao = chongwenbao_Res.data
                    localStorage.setItem('province_score_chongwenbao', JSON.stringify(chongwenbao_Res.data))
                    
                    that.province_score_toudang_gailv = toudang_gailv_Res.data
                    localStorage.setItem('province_score_toudang_gailv', JSON.stringify(toudang_gailv_Res.data))
                })
            )
        },
        get_province_zhanshi_fangshi() {
            let that = this
            axios.get(
                that.oss_sheng_list.province_zhanshi_fangshi, {}
            ).then(function (res) {
                that.province_zhanshi_fangshi = res.data
                for (let i in that.province_zhanshi_fangshi) {
                    if (that.province_zhanshi_fangshi[i]['batch_pre'] === "ben") {
                        that.batch_info = that.province_zhanshi_fangshi[i]
                        that.batch_id = that.batch_info['batch_id'] || 0
                        break
                    }
                }
                that.get_chongwenbao()
                localStorage.setItem('province_zhanshi_fangshi', JSON.stringify(res.data))
            }).catch(function (err) {
            });
        },
        province_score_toudang_gailv_json() {
            let that = this
            let url = that.oss_sheng_list.province_score_toudang_gailv.replace('placeholder', this.province_id + '/' + this.base_info.class_id + '/' + this.batch_id + '/' + this.base_info.score)
            axios.get(
                url, {}
            ).then(function (res) {
                that.province_score_toudang_gailv = res.data
            }).catch(function (err) {
                //console.log(err)
                
            });
        },
        province_score_gailv_json() {
            let that = this
            let url = that.oss_sheng_list.province_score_gailv.replace('placeholder', this.province_id + '/' + this.base_info.class_id + '/' + this.batch_id + '/' + this.base_info.score)
            axios.get(
                url, {}
            ).then(function (res) {
                that.province_score_gailv = res.data
            }).catch(function (err) {
                //console.log(err)
                
            });
        },
        province_score_chongwenbao_json() {
            let that = this
            let url = that.oss_sheng_list.province_score_chongwenbao.replace('placeholder', this.province_id + '/' + this.base_info.class_id + '/' + this.batch_id + '/' + this.base_info.score)
            axios.get(
                url, {}
            ).then(function (res) {
                that.province_score_chongwenbao = res.data
            }).catch(function (err) {
                //console.log(err)
                
            });
        },
        no_match_major() {
            ElMessage({
                dangerouslyUseHTMLString: true,
                message: "<strong>选科不匹配</strong>",
                type: 'warning',
                offset: 40,
            })
        },
        batch_change(e) {
            for (let i in this.province_zhanshi_fangshi) {
                if (this.province_zhanshi_fangshi[i]['batch_id'] == e) {
                    this.batch_info = this.province_zhanshi_fangshi[i]
                    this.batch_id = this.batch_info.batch_id
                    break;
                }
            }
            this.plans()
        },
        get_oss_list() {
            let that = this
            axios.get(
                api.oss.list + '?t=' + (Date.now() + ''), {}
            ).then(function (res) {
                that.oss_url_list = res.data
                that.oss_school_extra()
                that.oss_jianzhang_list()
                that.oss_first_class()
                that.oss_xuekepinggu()
                that.oss_kaishezhuanye()
            }).catch(function (err) {
            });
        },
        oss_school_extra() {
            let that = this
            let url = that.oss_url_list.school_info.replace('placeholder', this.school_id)
            axios.get(
                url, {}
            ).then(function (res) {
                let regex = /font-size:\s*[^;]+;/g;
                that.school_extra_info = res.data
            }).catch(function (err) {
            });
        },
        oss_jianzhang_list() {
            let that = this
            let url = that.oss_url_list.school_recruit.replace('placeholder', this.school_id)
            axios.get(
                url, {}
            ).then(function (res) {
                that.short_enroll_list_info = res.data
                that.enroll_list_info = res.data
            }).catch(function (err) {
            });
        },
        oss_first_class() {
            let that = this
            let url = that.oss_url_list.school_yiliuxueke.replace('placeholder', this.school_id)
            axios.get(
                url, {}
            ).then(function (res) {
                that.first_class_info = res.data
            }).catch(function (err) {
            });
        },
        oss_xuekepinggu() {
            let that = this
            let url = that.oss_url_list.school_xuekepinggu.replace('placeholder', this.school_id)
            axios.get(
                url, {}
            ).then(function (res) {
                that.subject_review_info = res.data
            }).catch(function (err) {
            });
        },
        oss_kaishezhuanye() {
            let that = this
            let url = that.oss_url_list.school_open_major.replace('placeholder', this.school_id)
            axios.get(
                url, {}
            ).then(function (res) {
                that.department_info = res.data
            }).catch(function (err) {
            });
        },
        change() {
        },
        sub_plans_list(obj) {
            let sub_plan_ids = obj.sub_plan_ids
            let major_limit = obj.major_limit
            //let index = obj.school_id + '_' + obj.major_group_code + '_' + obj.danlie_biaoshi
            let index = obj.danlie_group_key
            
            this.subTableData = []
            if (this.sub_favorite_list[index] === undefined) {
                this.sub_favorite_list[index] = []
            } else {
                this.subTableData = this.sub_favorite_list[index]
                return false
            }
            for (let i in sub_plan_ids) {
                let plan_id = sub_plan_ids[i]
                
                this.sub_favorite_list[index].push({
                    ...this.plan_info, ...{
                        'plan_id': plan_id,
                        'id': plan_id,
                        'major_limit': obj.major_limit
                    }
                })
                this.subTableData.push({
                    ...this.plan_info, ...{
                        'plan_id': plan_id,
                        'id': plan_id,
                        'major_limit': obj.major_limit
                    }
                })
                
                let key = 'province_plans_' + this.batch_info.batch_pre
                let url = this.oss_sheng_list[key] || ''
                url = url.replace('placeholder', this.province_id + '/' + this.batch_id + '/' + plan_id)
                if (url === '') {
                    return false
                }
                http.get(url, {}).then(data => {
                    for (let j in this.sub_favorite_list[index]) {
                        if (this.sub_favorite_list[index][j]['plan_id'] === data.id) {
                            data.major_limit = major_limit
                            data.collection = -2
                            this.sub_favorite_list[index][j] = data
                            break
                        }
                    }
                    for (let j in this.subTableData) {
                        if (this.subTableData[j]['plan_id'] === data.id) {
                            data.major_limit = major_limit
                            data.collection = -2
                            this.subTableData[j] = data
                            break
                        }
                    }
                }).catch(data => {
                })
            }
        },
        handleClose() {
        },
        initMap(school_name = '') {
            let that = this
            AMapLoader.load({
                key: "8471b39e4309c73de9e81395039d1b01",             // 申请好的Web端开发者Key，首次调用 load 时必填
                version: "2.0",      // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                plugins: ['AMap.PlaceSearch'],       // 需要使用的的插件列表，如比例尺'AMap.Scale'等
            }).then((AMap) => {
                const {Map, PlaceSearch} = AMap
                
                const amap = new Map('gaodeditu', {
                    center: [120.980795, 31.385476],
                    zoom: 10,
                    resizeEnable: true
                });
                
                const placeSearch = new PlaceSearch({
                    pageSize: 10, // 单页显示结果条数
                    pageIndex: 1, // 页码
                    city: "010", // 兴趣点城市
                    citylimit: false,  //是否强制限制在设置的城市内搜索
                    map: amap, // 展现结果的地图实例
                    autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
                });
                //关键字查询
                placeSearch.search(school_name, (status, result) => {
                    //console.log(status);
                    //console.log(result);
                });
            }).catch(e => {
                //console.log(e);
            })
        },
        schoolTypeClick(pane, ev) {
            if (pane.props.name === 'info' && this.show_school_info === true) {
                this.initMap(this.school_name)
                this.show_school_info = false
            }
            if (pane.props.name === 'plan') {
                if (this.need_login) {
                    this.no_login = true
                } else {
                    this.plans()
                }
            }
            this.show_enroll_detail = false
        },
        show_enroll_info(id, title) {
            let that = this
            that.school_type = 'recruit'
            let url = that.oss_url_list.school_jianzhangxiangqing.replace('placeholder', id)
            axios.get(
                url, {}
            ).then(function (res) {
                //console.log(res.data)
                that.show_enroll_detail = !that.show_enroll_detail
                that.enroll_detail = res.data.content
                that.enroll_detail_title = title
                that.tab = 2
            }).catch(function (err) {
            });
        },
        show_enroll_detail_btn() {
            this.show_enroll_detail = !this.show_enroll_detail
        },
        show_base_school_info() {
            this.show_school_info = !this.show_school_info
        },
        show_more_school_info() {
            this.more_school_info = this.school_extra_info.content
            this.show_school_info = !this.show_school_info
        },
        school_extra() {
            let that = this
            axios.get(
                api.school.extra, {params: {'school_id': this.school_id}}
            ).then(function (res) {
                //console.log(res)
                if (res.data.code === 10000) {
                    that.school_extra_info = res.data.data
                }
            }).catch(function (err) {
            });
        },
        score_class_change() {
            this.scores(parseInt(this.score_class))
        },
        scores(school_class = 0) {
            let that = this
            let params = {'school_id': this.school_id}
            if (school_class > 0) {
                params.class_type = school_class
            }
            axios.get(
                api.school.scores, {params: params}
            ).then(function (res) {
                //console.log(res)
                if (res.data.code === 10000) {
                    that.score_list = res.data.data
                    if (that.score_list.length === 0) {
                        that.score_empty = '暂无数据'
                    }
                }
            }).catch(function (err) {
            });
        },
        search_recruit_btn() {
            this.enroll_list(this.search_recruit)
        },
        enroll_list(search_recruit = '') {
            this.enroll_list_info = []
            
            for (let i in this.short_enroll_list_info) {
                if (this.short_enroll_list_info[i]['title'].search(search_recruit) > -1) {
                    this.enroll_list_info.push(this.short_enroll_list_info[i])
                }
            }
            if (this.enroll_list_info.length === 0) {
                this.enroll_list_empty = '暂无数据'
            }
        },
        first_class() {
            let that = this
            axios.get(
                api.school.first_class, {params: {'school_id': this.school_id}}
            ).then(function (res) {
                //console.log(res)
                if (res.data.code === 10000) {
                    that.first_class_info = res.data.data
                    if (that.first_class_info.length === 0) {
                        that.first_class_empty = '暂无数据'
                    }
                }
            }).catch(function (err) {
            });
        },
        special_major() {
            let that = this
            axios.get(
                api.school.special_major, {params: {'school_id': this.school_id}}
            ).then(function (res) {
                //console.log('国家特色专业')
                //console.log(res)
                if (res.data.code === 10000) {
                    that.special_major_info = res.data.data
                    if (that.special_major_info.length === 0) {
                        that.special_major_empty = '暂无数据'
                    }
                }
            }).catch(function (err) {
            });
        },
        subject_review() {
            let that = this
            axios.get(
                api.school.subject_review, {params: {'school_id': this.school_id}}
            ).then(function (res) {
                //console.log(res)
                if (res.data.code === 10000) {
                    that.subject_review_info = res.data.data
                    if (that.subject_review_info.length === 0) {
                        that.subject_review_empty = '暂无数据'
                    }
                }
            }).catch(function (err) {
            });
        },
        department() {
            let that = this
            axios.get(
                api.school.department, {params: {'school_id': this.school_id}}
            ).then(function (res) {
                //console.log('开设专业')
                //console.log(res)
                if (res.data.code === 10000) {
                    that.department_info = res.data.data
                    if (that.department_info.length === 0) {
                        that.department_empty = '暂无数据'
                    }
                }
            }).catch(function (err) {
            });
        },
        jobs_report() {
            let that = this
            axios.get(
                api.school.jobs_report, {params: {'school_id': this.school_id}}
            ).then(function (res) {
                //console.log(res)
                if (res.data.code === 10000) {
                    that.jobs_report_info = res.data.data
                }
            }).catch(function (err) {
            });
        },
        school_info(school_id, school_name) {
            //this.$router.push({path: '/school_info', query: {school_id: school_id, school_name: school_name}})
        },
        school_map(school_name) {
            //this.$router.push({path: '/school_map', query: {school_name: school_name}})
            
            const routeData = this.$router.resolve({path: '/school_map', query: {school_name: school_name}})
            window.open(routeData.href, '_blank')
        },
        plans(from = 0) {
            let that = this
            let params = {
                'school_id': this.school_id,
                'batch_id': this.batch_id,
                'application_form_id': 0,
                'page': 1,
                'page_size': 1000,
                'search_type': 3,
            }
            axios.post(
                api.match.list, params
            ).then(function (res) {
                that.form.page = res.data.data.current_page
                that.form.currentPage = parseInt(res.data.data.current_page)
                that.form.total = res.data.data.total
                that.form.page_size = res.data.data.per_page
                
                that.set_plans(res.data.data.data)
                if (res.data.code === 10000) {
                    that.plans_info = res.data.data
                    if (that.plans_info.length === 0) {
                        that.plans_empty = '暂无数据'
                    }
                }
            }).catch(function (err) {
            });
        },
        set_plans(list, no_sub = true) {
            //console.log(list)
            let search_data = []
            for (let i in list) {
                search_data.push({...this.plan_info, ...{'plan_id': list[i]['id'], 'id': list[i]['id']}})
            }
            
            if (no_sub) {
                this.tableData = search_data
            } else {
                this.subTableData = search_data
            }
            
            for (let i in search_data) {
                let key = 'province_plans_' + this.batch_info.batch_pre
                let url = this.oss_sheng_list[key] || ''
                url = url.replace('placeholder', this.province_id + '/' + this.batch_id + '/' + search_data[i]['id'])
                //console.log(url)
                if (url === '') {
                    return false
                }
                
                http.get(url, {}).then(data => {
                    for (let j in search_data) {
                        let plan_id = search_data[j]['id']
                        //console.log(data.id)
                        if (search_data[j]['id'] == data.id) {
                            let major_limit = search_data[j]['major_limit']
                            let match_status = parseInt(search_data[j]['match_status'])
                            
                            let match_str = ''
                            if (match_status === 1) {
                                match_str = '冲'
                            } else if (match_status === 2) {
                                match_str = '稳'
                            } else {
                                match_str = '保'
                            }
                            
                            if (no_sub) {
                                this.tableData[j] = data
                                this.tableData[j]['match_status'] = match_status
                                this.tableData[j]['collection'] = -2
                                if (data.sub_plan_ids) {
                                    this.tableData[j]['sub_plan_ids_length'] = data.sub_plan_ids.length || 0
                                } else {
                                    this.tableData[j]['sub_plan_ids_length'] = 0
                                }
                                this.tableData[j]['show_more'] = false
                                this.tableData[j]['major_limit'] = major_limit
                                this.tableData[j]['match_str'] = match_str
                                this.tableData[j]['plan_id'] = plan_id
                                this.tableData[j]['id'] = plan_id
                            } else {
                                this.subTableData[j] = data
                                this.subTableData[j]['match_status'] = match_status
                                this.subTableData[j]['collection'] = -2
                                if (data.sub_plan_ids) {
                                    this.tableData[j]['sub_plan_ids_length'] = data.sub_plan_ids.length || 0
                                } else {
                                    this.tableData[j]['sub_plan_ids_length'] = 0
                                }
                                this.subTableData[j]['show_more'] = false
                                this.subTableData[j]['major_limit'] = major_limit
                                this.subTableData[j]['match_str'] = match_str
                                this.subTableData[j]['plan_id'] = plan_id
                                this.subTableData[j]['id'] = plan_id
                            }
                            break
                        }
                    }
                }).catch(data => {
                })
            }
        },
        no_login_fun() {
            this.school_type = 'info'
            this.no_login = false
        },
        login_fun() {
            this.no_login = false
            this.$router.push({path: '/'})
        },
        open_vip_fun() {
            this.$router.push('/goods')
        },
        continue_favorite() {
            let index = this.favorites_index
            let list = this.favorites_list
            let type = this.favorites_type
            
            let url = this.ben_api
            if (this.from === 1) {
                url = this.ben_api
            } else if (this.from === 2) {
                url = this.preb_api
            } else if (this.from === 3) {
                url = this.vocation_api
            } else if (this.from === 4) {
                url = this.arts_api
            }
            
            let data = http.post(url + api.user.favorite, {
                "favorite_id": list.id
            })
            data.then(data => {
                //console.log(data)
                //console.log(data.data)
                if (data.code === 10000) {
                    if (type === 1) {
                        this.plans_info[index]['collection'] = -2
                    } else {
                        this.plans_info[index]['collection'] = -2
                    }
                    this.$notify({
                        title: '成功',
                        message: '选择成功',
                        type: 'success',
                        offset: 50,
                    });
                    this.favorites_status = false
                } else {
                    this.$notify.error({
                        title: '错误',
                        message: data.data.msg,
                        offset: 50,
                    });
                    this.favorites_status = false
                }
            })
        },
        favorite(index, list, type = 1) {
            let url = this.ben_api
            if (this.from === 1) {
                url = this.ben_api
            } else if (this.from === 2) {
                url = this.preb_api
            } else if (this.from === 3) {
                url = this.vocation_api
            } else if (this.from === 4) {
                url = this.arts_api
            }
            
            //console.log(url)
            
            if (list.collection === 1) {
                this.un_favorite(index, list, type)
            } else {
                if (list.major_remind_desc !== null && list.major_remind_desc.length > 0) {
                    this.favorites_index = index
                    this.favorites_list = list
                    this.favorites_type = type
                    this.favorites_status = true
                    this.major_remind_list = list.major_remind_desc
                } else {
                    this.major_remind_list = []
                    
                    let data = http.post(url + api.user.favorite, {
                        "favorite_id": list.plan_id
                    })
                    data.then(data => {
                        //console.log(data)
                        //console.log(data.data.sum)
                        if (data.code === 10000) {
                            this.plans_info[index]['collection'] = 1
                            this.$notify({
                                title: '成功',
                                message: '选择成功',
                                type: 'success',
                                offset: 50,
                            });
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: data.data.msg,
                                offset: 50,
                            });
                        }
                    })
                }
            }
            //console.log(list.id)
        },
        un_favorite(index, list, type = 1) {
            let url = this.ben_api
            if (this.from === 1) {
                url = this.ben_api
            } else if (this.from === 2) {
                url = this.preb_api
            } else if (this.from === 3) {
                url = this.vocation_api
            } else if (this.from === 4) {
                url = this.arts_api
            }
            
            let that = this
            //console.log(list.id)
            let data = http.post(url + api.user.un_favorite, {
                "favorite_id": list.id,
                "type": 1,
            })
            data.then(data => {
                //console.log(data)
                //console.log(data.data)
                if (data.code === 10000) {
                    if (type === 1) {
                        this.plans_info[index]['collection'] = 0
                    } else {
                        this.plans_info[index]['collection'] = 0
                    }
                    this.$notify({
                        title: '成功',
                        message: '取消选择成功',
                        type: 'success',
                        offset: 50,
                    });
                } else {
                    this.$notify.error({
                        title: '错误',
                        message: data.data.msg,
                        offset: 50,
                    });
                }
            })
        },
    }
};
</script>

<style lang="scss" scoped>

.container {
    display: flex;
    justify-content: space-between;
    
    .left {
        width: 100%;
        padding-bottom: 20px;
        background: var(--sub-bg);
        border-radius: 6px;
        position: relative;
        overflow: hidden;
        
        .bg {
            position: absolute;
            width: 100%;
            height: 270px;
            top: 0;
            z-index: 1;
        }
        
        .top {
            width: 100%;
            padding: 0 20px;
            height: 270px;
            overflow: hidden;
            position: relative;
            background: linear-gradient(93deg, #e93a29 0.32%, #ef7530 99.4%);
            
            .card {
                width: calc(100% - 40px);
                height: 100px;
                position: absolute;
                z-index: 2;
                border-radius: 6px;
                z-index: 99;
                padding: 20px;
                margin-top: 30px;
                display: flex;
                align-items: center;
                
                .logo {
                    width: 100px;
                    height: 100px;
                    margin-right: 20px;
                    border-radius: 50%;
                }
                
                .center {
                    width: calc(100% - 350px);
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    
                    .name {
                        font-size: 32px;
                        font-weight: 500;
                        color: #ffffff;
                        display: flex;
                        
                        .city {
                            color: #ffffff;
                            padding: 0 5px;
                            height: 21px;
                            font-size: 14px;
                            display: flex;
                            align-items: center;
                            margin-top: 15px;
                            margin-left: 10px;
                            font-weight: 400;
                            line-height: 21px;
                            border-radius: 4px;
                            border: 1px solid #ffffff;
                        }
                    }
                    
                    .types {
                        display: flex;
                        margin-bottom: 10px;
                        margin-top: 4px;
                        
                        div {
                            padding-left: 10px;
                            border-left: 1px solid #fff;
                            color: #ffffff;
                            font-size: 16px;
                            height: 16px;
                            line-height: 16px;
                            margin-right: 10px;
                            cursor: pointer;
                            
                            &:nth-of-type(1) {
                                padding-left: 0;
                                border: 0;
                            }
                        }
                    }
                    
                    .labels {
                        display: flex;
                        
                        div {
                            color: #fff;
                            font-size: 12px;
                            border-radius: 4px;
                            display: flex;
                            align-items: center;
                            border: 1px solid #fff;
                            padding: 0 4px;
                            margin-right: 10px;
                        }
                    }
                }
                
                .button {
                    width: 110px;
                    height: 36px;
                    border-radius: 6px;
                    line-height: 36px;
                    text-align: center;
                    cursor: pointer;
                    font-size: 18px;
                    margin-left: 50px;
                    color: #fff;
                    border: 1px solid #fff;
                }
            }
            
            .tabbar {
                width: calc(100% - 40px);
                display: flex;
                justify-content: space-between;
                position: absolute;
                bottom: 0;
                
                .onbar,
                .bar {
                    z-index: 2;
                    width: 33%;
                    height: 50px;
                    color: #fff;
                    border-top-right-radius: 6px;
                    border-top-left-radius: 6px;
                    line-height: 50px;
                    font-size: 20px;
                    text-align: center;
                    cursor: pointer;
                    background: #ffffff4d;
                }
                
                .onbar {
                    background: #fff;
                    color: var(--primary);
                }
            }
        }
        
        .bottom {
            margin-top: 40px;
            width: 840px;
            padding: 0 20px;
            
            .medal {
                width: 100%;
                height: 132px;
                display: flex;
                justify-content: left;
                
                .list {
                    width: 76px;
                    margin-left: 10px;
                    height: 110px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                    font-size: var(--font-1);
                    padding: 10px;
                    border-radius: 6px;
                    border: 1px solid var(--border);
                    
                    .img {
                        width: 36px;
                        height: 36px;
                    }
                    
                    .text {
                        margin-top: 10px;
                        text-align: center;
                        margin-bottom: 10px;
                    }
                    
                    .gang {
                        width: 20px;
                        height: 1px;
                        background: #dedede;
                    }
                }
            }
            
            .introduction {
                font-size: 14px;
                color: var(--font-2);
                line-height: 28px;
                margin-top: 20px;
            }
            
            .map {
                width: 100%;
                height: 350px;
                padding: 30px 0;
                border-bottom: 1px solid var(--border);
                
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            
            .title {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 36px;
                margin: 20px 0;
                
                .title_left {
                    height: 36px;
                    display: flex;
                    align-items: center;
                }
                
                img {
                    width: 4px;
                    height: 22px;
                    margin-right: 10px;
                }
                
                .font {
                    color: var(--font-1);
                    font-size: 24px;
                    flex-wrap: 700;
                }
                
                .more {
                    width: 89px;
                    height: 24px;
                    font-size: 16px;
                    color: var(--primary);
                    display: flex;
                    align-items: center;
                    
                    div:nth-of-type(2) {
                        margin-left: 5px;
                        font-size: 12px;
                    }
                    
                    &:hover {
                        color: #ff6455;
                    }
                }
                
                .detail {
                    color: var(--font-3);
                    font-size: 14px;
                    margin-top: 10px;
                    margin-left: 10px;
                }
            }
            
            .mien {
                width: 100%;
                height: 180px;
                display: flex;
                justify-content: space-between;
                
                img {
                    width: 270px;
                    height: 180px;
                    border-radius: 6px;
                }
            }
            
            .student {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                width: 100%;
                
                div {
                    background: #f5f4f8;
                    width: 386px;
                    height: 50px;
                    padding-left: 20px;
                    margin-bottom: 20px;
                    font-size: 14px;
                    line-height: 50px;
                    color: var(--font-1);
                    cursor: pointer;
                    
                    &:hover {
                        color: var(--primary);
                    }
                }
            }
            
            .table {
                margin: 0;
            }
        }
    }
}

.table > > > .el-table__header {
    padding: 0;
}
</style>
